/* eslint-disable */
// DnaSegmented — New-DNA segmented toggle (the prototype's .seg control).
// Single-value; options are string[] or {value,label}[]. Active segment gets
// the amber fill. Used for Sun/Optic (Optic · Sunglasses) on both modals.
import React from 'react';
import styles from './DnaSegmented.module.css';

function normalize(opts) {
  return (opts || []).map((o) => (typeof o === 'string' ? { value: o, label: o } : o));
}

export default function DnaSegmented({ label, required = false, options = [], value, onChange, error = false }) {
  const opts = normalize(options);
  return (
    <div className={styles.field}>
      {label && (
        <label className={styles.label}>{label}{required && <span className={styles.req}> *</span>}</label>
      )}
      <div className={`${styles.seg} ${error ? styles.err : ''}`} role="radiogroup">
        {opts.map((o) => {
          const active = String(o.value) === String(value);
          return (
            <button
              key={o.value}
              type="button"
              role="radio"
              aria-checked={active}
              className={`${styles.segBtn} ${active ? styles.segActive : ''}`}
              onClick={() => onChange && onChange(o.value)}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
